<section class="statements-page">
  <div class="page-head">
    <div>
      <h1>Statements</h1>
      <p class="intro">Browse uploaded statements and open their current status.</p>
    </div>
    <a class="btn primary" routerLink="/app/upload">Upload statement</a>
  </div>

  @if (isLoading) {
    <div class="card"><p>Loading statements...</p></div>
  }

  @if (!isLoading && errorMessage) {
    <div class="message error-banner">{{ errorMessage }}</div>
  }

  @if (!isLoading && !errorMessage && statements.length === 0) {
    <div class="card">
      <h2>No statements yet</h2>
      <p>Start by uploading your first statement.</p>
    </div>
  }

  @if (!isLoading && statements.length > 0) {
    <div class="table-card">
      <table>
        <thead>
        <tr>
          <th>Source</th>
          <th>Type</th>
          <th>Status</th>
          <th>Uploaded</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
          @for (statement of statements; track statement.id) {
            <tr>
              <td>{{ statement.sourceName }}</td>
              <td>{{ statement.type }}</td>
              <td><span class="status-pill">{{ statement.status }}</span></td>
              <td>{{ statement.uploadedAt | date:'medium' }}</td>
              <td>
                <a class="row-link" [routerLink]="['/app/statements', statement.id]">Open</a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>
